// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BH7gFFgSEJshOx4YesMo{border-bottom:1px var(--border-neutral-default)solid;height:auto;min-height:132px;padding:20px 20px 19px 19px}.BH7gFFgSEJshOx4YesMo.WyramIXTBjsxf3RzK4pe{justify-content:center;align-items:center;width:100%;display:flex}.BH7gFFgSEJshOx4YesMo .OzkOznxPoE1O9hB6LYqB{justify-content:space-between;align-items:center;margin-top:20px;display:flex}.BH7gFFgSEJshOx4YesMo .OzkOznxPoE1O9hB6LYqB.UpYhifcih09rYXDNk6i_{justify-content:flex-start;gap:8px}.BH7gFFgSEJshOx4YesMo .pZLWGSccTkkYrfyO1fWW{width:83px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BH7gFFgSEJshOx4YesMo`,
	"loader": `WyramIXTBjsxf3RzK4pe`,
	"actions": `OzkOznxPoE1O9hB6LYqB`,
	"actionsModal": `UpYhifcih09rYXDNk6i_`,
	"buttonFixed": `pZLWGSccTkkYrfyO1fWW`
};
export default ___CSS_LOADER_EXPORT___;
